import React from 'react';
import classNames from 'classnames/bind';
import styles from './index.module.pcss';
import properties from '../../../modules/ajio-util/properties';
import { replaceWithJioCDN } from '../../../utils/imageHandling';

const imageBaseUrl: string = properties.getProperty('imageBaseUrl');
interface LoaderProps {
  url?: string;
}
const Loader = ({ url }: LoaderProps): JSX.Element => {
  const cx = classNames.bind(styles);
  return (
    <div className={cx('loader')}>
      <img className={cx('imgClass')} alt="Ajio loader" src={replaceWithJioCDN(url)} />
    </div>
  );
};
Loader.defaultProps = {
  url: `${imageBaseUrl}/static/img/refreshsitespinner_2.gif`
};
export default Loader;
